var getURLParameter = function (sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) 
        {
            return sParameterName[1];
        }
    }
};

var __user_favorites = [];
var __river_cache = false;

var makerLoaded = function(config) {
	
	$("#filter-row").show();
	
	$(frames['maker-frame'].document).on('click',".sign-in-button", function() {
	  parent.window.location = $(this).attr("href") + "?last=" + encodeURIComponent(window.location.pathname) + encodeURIComponent(window.location.search) + encodeURIComponent(window.location.hash);
	
	  return false;
	});
	
	//Lets figure out what to do with the content river.
	var jar = frames['maker-frame'].getJar();
	var knicks = frames['maker-frame'].getKnicks();
	var filterParam = $.query.get('filter');
	
	var data = {};
	data.search = [];
	data.collections = [];
	data.types = [];
	data.price = [];
	
	if (config && config.collections) {
		data.collections = config.collections;
	}
	
	if (config && config.search) {
		data.search = config.search;
	}
	
	if (config && config.price) {
		data.price = config.price;
	}
  
	for(var i in filterParam) {
		if(typeof filterParam[i] != "function") {
			
			if (filterParam[i].indexOf("COLLECTION") == 0) {
				data.collections.push(filterParam[i].replace("COLLECTION:", "").trim())
			} else {
				var tmp = filterParam[i].split("-");
				if (tmp.length === 2 && !isNaN(tmp[0]) && !isNaN(tmp[1])) {
					data.price.push(data.search[i]);
					selected.push({"tag":"price", "value":data.search[i]});
				} else {
					data.search.push(data.search[i]);
					selected.push({"tag":"search", "value":data.search[i]});
				}
			}
		}
	}
	
	if (data.collections.length > 0) {
		for (var i=0; i < data.collections.length; i++) {
			var tmp = $('li[data-value="COLLECTION:' + data.collections[i] + '"]');
			if($(tmp).length) {
			  var tag = $(tmp).parent().data('tag');
			  var value = $(tmp).data("value");
				
			  if(!$(tmp).hasClass("selected")) {
				selected.push({tag: tag, value:value});
			  }
		  
			  $(tmp).toggleClass("selected");
			  
			  // Toggle Checkmark
			  if( !$(tmp).hasClass('selected') ) {
				$(tmp).find('i.fa').remove();
			  } else {
				$(tmp).append('<i class="fa fa-check"></i>');
			  }
			}
		}
	}
	
	if (data.search.length > 0) {
		for(i in data.search) {
			if (data.search[i]) {
				selected.push({"tag":"search", "value":data.search[i]});
			}
		}
	}
	
	if (data.price.length > 0) {
		for(i in data.price) {
			selected.push({"tag":"price", "value":data.price[i]});
		}
	}
	
	buildFilters();

	updateContentRiver(data,{showModal:true});
	$("#maker-frame").show();
	$("#maker-frame-wrapper").show();
	$("#home-slider").hide(); 
};

var addKnicks = function(knicks) {
	if (knicks.length) {
		addKnick(knicks[0]).then(function() {
			knicks.shift()
			addKnicks(knicks);
		});
	}
}

var addKnick = function(knick) {
	var dfd = jQuery.Deferred();

  if(!frames['maker-frame'].window.location.host) {
    loadBlankMaker(function() {
		if (typeof fqp !== "undefined") {
			fbq('track', "AddToWishlist");
		}
     	frames['maker-frame'].addKnickToMaker(knick).then(function() {
			dfd.resolve();	
		});
      	makerLoaded();
    });
  } else {
  	frames['maker-frame'].addKnickToMaker(knick).then(function() {
		dfd.resolve();	
	}); 
  }
  return dfd.promise();
};

var updateJar = function(jar, callback) {
  if(!frames['maker-frame'].window.location.host) {
    loadBlankMaker(function() {
		if (typeof fqp !== "undefined") {
			fbq('track', "AddToWishlist");
		}
     	frames['maker-frame'].updateJarToMaker(jar,callback);
      	makerLoaded();
    });
  } else {
  	frames['maker-frame'].updateJarToMaker(jar,callback); 
  }
};

var buildKnick = function(data) {
  var variant_id, variant_name, qty;
  if(data.data("variant-name") && data.data("variant-name").length > 0) {
		variant_name = data.data("variant-name");
  } else {
		variant_name = $(data).find("select.variant2").val() || $(data).find(".single-option-selector[data-option=option1]").val();
	
		if ($(data).find(".single-option-selector[data-option=option2]").val()) {
			variant_name += " / " + $(data).find(".single-option-selector[data-option=option2]").val();
		}
  }

  if(data.data("qty")) {
		qty = data.data("qty");
  } else {
		qty = $(data).find(".variant1").val() || $(data).find("#product-quantity").val();
  }
  
  if (!qty) {
		qty = 1;
  }
  var knicks = [];
	
	if(data.data("item-handle")) {
  
		if (typeof variant_name === 'undefined' || variant_name.indexOf('undefined') >= 0) {
	
			variant_id = data.data('item-variant-id-1');
			variant_price = data.data('item-variant-price-1');
			variant_price_currency = data.data('item-variant-price-currency-1');
		
			variant_available = data.data('item-variant-available-1');
			variant_inventory_quantity = data.data('item-variant-inventory-quantity-1');
			
			variant_name = data.data('item-variant-title-1');
			
			if(data.data('item-variant-image-1') && data.data('item-variant-image-1').length > 0) {
				variant_image = data.data('item-variant-image-1');
				variant_image_medium = data.data('item-variant-image-medium-1');
			} else {
				variant_image = data.data('item-image');
				variant_image_medium = data.data('item-image-medium');
			}
		}
	
		//Set up default values.
		variant_compress = data.data('item-compress');
		variant_width = data.data('item-width');
		variant_length = data.data('item-length');
		variant_height = data.data('item-height');
		
		if(data.data('item-compress') && data.data('item-compress').length > 0) {
			variant_compress = data.data('item-compress');
		} else {
			variant_compress = 0; 
		}
		
		
		//Find the right variant id.
		var v_count = data.data('item-variant-count');
	
		if(variant_name) {
			var split_arr = variant_name.split('/');
			for(var i=1; i <= v_count; i++) {
				var found = true;
				split_tmp = data.data('item-variant-title-' + i).toString().split('/');
	
				for(var j=0; j < split_arr.length; j++) {
					if(split_arr[j] && split_tmp[j] && split_arr[j].trim() !== split_tmp[j].trim()) { 
						found = false; 
					}
				}
	
				if(found) {
					variant_id = data.data('item-variant-id-' + i);
					variant_price = data.data('item-variant-price-' + i);
					variant_price_currency = data.data('item-variant-price-currency-' + i);
			
					variant_available = data.data('item-variant-available-' + i);
					variant_inventory_quantity = data.data('item-variant-inventory-quantity-' + i);
	
					if(data.data('item-variant-title-' + i) != "Default Title") {
						variant_title = data.data('item-variant-title-' + i);
					} else {
						variant_title = ""; 
					}
	
					if(data.data('item-variant-image-' + i) && data.data('item-variant-image-' + i).toString().length > 0) {
						variant_image = data.data('item-variant-image-' + i);
						variant_image_medium = data.data('item-variant-image-medium-' + i);
					} else {
						variant_image = data.data('item-image');
						variant_image_medium = data.data('item-image-medium');
					}

					if(data.data('item-variant-width-' + i) && data.data('item-variant-width-' + i).toString().length > 0) {
						variant_width = data.data('item-variant-width-' + i);
					}
	
					if(data.data('item-variant-length-' + i) && data.data('item-variant-length-' + i).toString().length > 0) {
						variant_length = data.data('item-variant-length-' + i);
					}
	
					if(data.data('item-variant-height-' + i) && data.data('item-variant-height-' + i).toString().length > 0) {
						variant_height = data.data('item-variant-height-' + i);
					}
	
					if(data.data('item-variant-compress-' + i) && data.data('item-variant-compress-' + i).toString().length > 0) {
						variant_compress = data.data('item-variant-compress-' + i);
					}
				}
			}
		}
		
		if(variant_id) {
			for(var i=0; i < qty; i++) {
				var knick = {
					product_id: data.data('product-id'),
					variant_id: variant_id,
					variant_available: variant_available,
					variant_inventory_quantity: variant_inventory_quantity,
					product_title: data.data('item-name'),
					handle: data.data('item-handle'),
					variant_title:variant_title,
					price: variant_price,
					price_currency: variant_price_currency,
					length: variant_length,
					width: variant_width,
					height: variant_height,
					compress: variant_compress,
					vendor: data.data('item-vendor'),
					vendor_handle:data.data('item-vendor-handle'),
					vendor_profile:data.data('item-vendor-profile')
				};
	
				if(variant_image) {
					knick.image = variant_image;
					knick.image_medium = variant_image_medium;
				} else {
					knick.image = data.data('item-image');
					knick.image_medium = data.data('item-image-medium');
				}
				
				if(!knick.width) {
				console.log("NO WIDTH",knick);
					console.log("No width for knick");
					continue; 
				}
				
				if(!knick.length) {
					console.log("No height for knick");
					continue;
				}
				
				if(!knick.height) {
					console.log("No height for knick");
					continue;
				}
			
			knicks.push(knick);
			}
		}
	}

  return knicks;
};




var scrollerProductOptionsChanged = function(variant, selector, e, i) {

  if (!variant) return;
 
  var $modal = $(selector.variantIdField).closest('[data-product-id]'),
      slide_variants = $modal.data('slide_variants');
  
  if (!$modal.data("requestedCarouselVariant") && $modal.data("currentOptionsVariant") && variant.id == $modal.data("currentOptionsVariant")) return;

  $modal.data("currentOptionsVariant",variant.id);

  if ( !$.isEmptyObject(slide_variants) ) {
    if ($modal.data("requestedCarouselVariant") && variant.id != $modal.data("requestedCarouselVariant")) {
      // console.log('requesting variant %d again',requestedCarouselVariant);
      $modal.data("ProductOptions").selectVariant($modal.data("requestedCarouselVariant"));
      return;
    }
    // console.log('$carousel.flexslider(%d) %d',slide_variants[variant.id],variant.id);

	if($modal.find('.slider-nav.slick-initialized').length) {
		$modal.find('.slider-nav.slick-initialized').slick('slickGoTo',slide_variants[variant.id]);
	}
  }

  // console.log('setting requestedCarouselVariant false');
  $modal.data("requestedCarouselVariant", false);

  // Whether the variant is in stock or not, we can update the price and compare at price.
	$modal.trigger("price-update",{"compare_at_price": Shopify.formatMoney(variant.compare_at_price, ''), "price": Shopify.formatMoney(variant.price, '')});
	$modal.trigger("variant-update",variant.id);

  // Show Out of Stock, disable buttons
  $modal.find('#variant-container .selector-wrapper:last').toggleClass('unavailable', !variant.available);
  $modal.find('div.buttons > button, #make-gift').prop('disabled', function(){
    return !variant.available;
  });

  // For the buildKnick() event listener
  //$(selector.variantIdField).trigger('change');
};


var initKnackModalScroller = function(modal,productJSON,variant_id) { 

	var slide_variants = {};
	var handle = $(modal).data('item-handle');
	var ProductOptions = {};
	var startAt = 0;
	
	$(modal).find('.slider-nav').on('init', function(e, slick, currentSlideIndex, nextSlideIndex) {

		$(modal).find(".slider-nav .slick-slide").each(function(i) {
			var variant_id = $(this).data('variant-id');
			if(variant_id) {
				slide_variants[variant_id] = $(this).data('slick-index');
			}
		});
		
		// Stash that object on the carousel element
		$(modal).data('slide_variants', slide_variants);
		$(modal).data("requestedCarouselVariant", false);
		
		var variant_id = $(modal).find(".slider-nav .slick-current").data('variant-id');
		if (variant_id) {
		  
		  $(modal).data("requestedCarouselVariant", variant_id);
		  
		  if ($(modal).data("ProductOptions") && $(modal).data("ProductOptions").selectVariant) {
			  $(modal).data("ProductOptions").selectVariant(variant_id);
		  }
		}
	});
	
	$(modal).find('.slider-nav').on('afterChange', function(e, slick, currentSlideIndex, nextSlideIndex) {
		var $currentSlide = $(modal).find(".slider-nav .slick-slide[data-slick-index=" + currentSlideIndex + "]");

		ga('send', 'event', 'product', 'view-image',$(modal).data('item-handle') + " | " + $currentSlide.find("img").attr("src"));

		var variant_id = $currentSlide.data('variant-id');

		if (variant_id) {
		  $(modal).data("requestedCarouselVariant", variant_id);
		  
		  if ($(modal).data("ProductOptions") && $(modal).data("ProductOptions").selectVariant) {
			  $(modal).data("ProductOptions").selectVariant(variant_id);
		  }
		}
	});
	
	slidesToShow = 4;
	if(productJSON && productJSON.product && productJSON.product.images.length <= 4 && productJSON.product.images.length >=1) {
		slidesToShow = productJSON.product.images.length;
	}
	
	$(modal).find('.slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		nextArrow:'<img class="a-right control-c next slick-next" src="//cdn.shopify.com/s/files/1/0965/7972/files/right-arrow-circle-pdp.png?v=12925318073648116848">',
		prevArrow:'<img class="a-left control-c prev slick-prev" src="//cdn.shopify.com/s/files/1/0965/7972/files/left-arrow-circle-pdp.png?v=16196127737229291433">',
		fade: true,
		asNavFor: '.slider-nav'
	});
	
	if(slidesToShow <=0) {
		slidesToShow = 1;
	}
  
	$(modal).find('.slider-nav').slick({
		slidesToShow: slidesToShow,
		slidesToScroll: 1,
    swipeToSlide: true,
		asNavFor: '.slider-for',
		arrows: false,
		dots: false,
		focusOnSelect: true,
		vertical:true,
		adaptiveHeight: true,
		centerPadding: "10px",
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows:false,
					vertical:false
				}
			}
		]
	});
	
	if (productJSON && productJSON.product) {
		
		$('div.buttons > button, #make-gift').prop('disabled', function(){
			return !productJSON.product.available;
		});
		
		var variants = [];
		
		for(var i=0; i < productJSON.product.variants.length; i++) {
			if(	productJSON.product.variants[i].available ) {
				variants.push(productJSON.product.variants[i]);
			}
		}
		
		productJSON.product.variants = variants;
		
		if (productJSON.product.variants.length >= 1 && productJSON.product.variants[0].title != "Default Title" ) {
			ProductOptions = new Shopify.OptionSelectors($(modal).find(".variant-option-selector").attr("id"), {
			  product: productJSON.product,
			  onVariantSelected: scrollerProductOptionsChanged
			});
			
			if(productJSON.product.options.length == 1) {
			  $singleOptionSelector = ProductOptions.selectors[0].element;
			  
			  $('<label for="' + $singleOptionSelector.id + '">'+ ProductOptions.selectors[0].name + '</label>').insertBefore($singleOptionSelector);
			}
			
			if (productJSON.product.available && productJSON.product.options.length > 1) {
				Shopify.linkOptionSelectors(productJSON.product, ".knick-wrapper[data-item-uid=" + $(modal).data('item-uid') + "]");
			}
		}
	}

	$(modal).data("ProductOptions", ProductOptions)

	$(modal).data("requestedCarouselVariant", false);
	
  return $(modal);
};

var ProductOptionsChanged = function(variant, selector, e, i) {

  if (!variant) return;
 
  var $modal = $(selector.variantIdField).closest('[data-product-id]'),
      $carousel = $modal.find('.image-carousel'),
      slide_variants = $carousel.data('slide_variants');
  
  if (!$carousel.data("requestedCarouselVariant") && $carousel.data("currentOptionsVariant") && variant.id == $carousel.data("currentOptionsVariant")) return;
  // console.log('ProductOptionsChanged(%d)',variant.id);

  $carousel.data("currentOptionsVariant",variant.id);
  // console.log('currentOptionsVariant =',currentOptionsVariant);

  
  // console.log('requestedCarouselVariant =',requestedCarouselVariant);

  if ( !$.isEmptyObject(slide_variants) ) {
    if ($carousel.data("requestedCarouselVariant") && variant.id != $carousel.data("requestedCarouselVariant")) {
      // console.log('requesting variant %d again',requestedCarouselVariant);
      $carousel.data("ProductOptions").selectVariant($carousel.data("requestedCarouselVariant"));
      return;
    }
    // console.log('$carousel.flexslider(%d) %d',slide_variants[variant.id],variant.id);
    $carousel.flexslider( slide_variants[variant.id] );
  }

  // console.log('setting requestedCarouselVariant false');
  $carousel.data("requestedCarouselVariant", false);

  // Whether the variant is in stock or not, we can update the price and compare at price.
  $carousel.trigger("price-update",{"compare_at_price": Shopify.formatMoney(variant.compare_at_price, ''), "price": Shopify.formatMoney(variant.price, '')});
	$carousel.trigger("variant-update",variant.id);

  // Show Out of Stock, disable buttons
  $modal.find('#variant-container .selector-wrapper:last').toggleClass('unavailable', !variant.available);
  $modal.find('div.buttons > button').prop('disabled', function(){
    return !variant.available;
  });

  // For the buildKnick() event listener
  $(selector.variantIdField).trigger('change');
  
  //Trigged the other tabs event, if applicable.
  if(selector.selectors[0].element.id.indexOf("_inside-") >= 0) {
	init_about.push(function() {
		var dfd = jQuery.Deferred();
		
		var aboutId = selector.selectors[0].element.id.replace("_inside-", "_about-");
		var value = $("#" + selector.selectors[0].element.id).val();
		
		$("#" + aboutId).val(value);
		$("#" + aboutId).change();
		dfd.resolve();
		return dfd.promise();
	});
  }
};


var initKnackModalCarousel = function(modal,productJSON,variant_id) { 

  var $carousel = $(modal).find('.image-carousel'),
      slide_variants = {};
	var handle = $(modal).data('item-handle');
	var ProductOptions = {};
	var startAt = 0;

	if (productJSON && productJSON.product) {
		if (productJSON.product.variants.length >= 1 && productJSON.product.variants[0].title != "Default Title" ) {
			if($(modal).find(".variant-option-selector").length > 0) {
				ProductOptions = new Shopify.OptionSelectors($(modal).find(".variant-option-selector").attr("id"), {
					product: productJSON.product,
					onVariantSelected: ProductOptionsChanged
				});
				
				if (variant_id) {
					$(modal).find(".slides li").each(function(i) {
						if ($(this).data("variant-id") == variant_id) {
							startAt = i;
							return;
						}
					});
				}
				
				if(productJSON.product.options.length == 1) {
					$singleOptionSelector = ProductOptions.selectors[0].element;
					$('<label for="' + $singleOptionSelector.id + '">'+ ProductOptions.selectors[0].name + '</label>').insertBefore($singleOptionSelector);
				}
				
				if (productJSON.product.available && productJSON.product.options.length > 1) {
					
					if($(modal).closest("#knack-contents")) {
						Shopify.linkOptionSelectors(productJSON.product, "#knack-contents .knick-wrapper[data-item-uid=" + $(modal).data('item-uid') + "]");
					} else if($(modal).closest("#knack-inside")) {
						Shopify.linkOptionSelectors(productJSON.product, "#knack-inside .knick-wrapper[data-item-uid=" + $(modal).data('item-uid') + "]");
					} else {
						Shopify.linkOptionSelectors(productJSON.product, ".knick-wrapper[data-item-uid=" + $(modal).data('item-uid') + "]");
					}
					//Shopify.linkOptionSelectors(productJSON.product, ".knick-wrapper[data-item-uid=" + $(modal).data('item-uid') + "]");
				}
			}
		}
	}

	$carousel.data("ProductOptions", ProductOptions)

	$carousel.data("requestedCarouselVariant", false);

  // Initialize flexslider for carousel
  $carousel.flexslider({
    // namespace: 'modal-carousel-',
    animation: 'slide',
    animationSpeed: 500,
		startAt: startAt,
    // animationLoop: false,
    keyboard: true,
    slideshow: false,
    start: function(slider) {
      // Build associative array of each variant's slide index
      if ( !slider.slides ) return;
      for (var i = 0; i < slider.slides.length; i++) {
        var slide = slider.slides[i];
        var variant_id = $(slide).data('variant-id');
        if (variant_id)
          slide_variants[variant_id] = i;
      }
      // Stash that object on the carousel element
      $carousel.data('slide_variants', slide_variants);
			$carousel.data("requestedCarouselVariant", false);
	  
			var variant_id = $(slider.slides[slider.currentSlide]).data('variant-id');
			if (variant_id) {
		
				$carousel.data("requestedCarouselVariant", variant_id);
				
				if ($carousel.data("ProductOptions").selectVariant) {
					$carousel.data("ProductOptions").selectVariant(variant_id);
				}
			}
			
			$carousel.data("loaded", true);
			$carousel.trigger("loaded");
    },
    after: function(slider) {
      // console.log('---- after ----', slider.currentSlide);
			ga('send', 'event', 'product', 'view-image',$carousel.closest(".modal-body").data('item-handle') + " | " + $(slider.slides[slider.currentSlide]).find("img").attr("src"));
      var variant_id = $(slider.slides[slider.currentSlide]).data('variant-id');
      if (variant_id) {
        // console.log('ProductOptions.selectVariant(%d)',variant_id);
        // console.log('setting requestedCarouselVariant to', variant_id);
				$carousel.data("requestedCarouselVariant", variant_id);
				
				if ($carousel.data("ProductOptions").selectVariant) {
					$carousel.data("ProductOptions").selectVariant(variant_id);
				}
      }
    },
  });

  // Vertically center slide images
  $carousel.imagesLoaded().always(function(instance){
    for (var i = 0; i < instance.images.length; i++) {
      var image = instance.images[i];
      if ( image.isLoaded ) {
		
		if (image.img.height > $carousel.find(".flex-viewport").height()) {
			$(image.img).css('height', $carousel.find(".flex-viewport").height());
		}
        $(image.img).css('margin-top', (($carousel.find(".flex-viewport").height() - image.img.height) / 2) + 'px');
      }
    }
    $carousel.addClass('loaded');
  });
  
  return $carousel;
};

var knickFitInJar = function(knick,jar) {
    var fit = false;
    var opening_width;
    var opening_length;

    if(!knick.compress) {
      knick.compress = 0;
    }

    opening_width = jar.open_width;
    opening_length = jar.open_length;

    if(opening_width && opening_length) {
      var width = (knick.width) - (knick.width * knick.compress);
      var length = (knick.length) - (knick.length * knick.compress);
      var height = (knick.height) - (knick.height * knick.compress);

      // DEBUG && console.log(width, length, height);

      if (width <= opening_width && length <= opening_length && height <= jar.contain_depth) {
          fit = true;
      } else if (width <= opening_length && length <= opening_width && height <= jar.contain_depth) {
          fit = true;
      } else if (width <= opening_width && length <= jar.contain_depth && height <= opening_length) {
          fit = true;
      } else if (width <= opening_length && length <= jar.contain_depth && height <= opening_width) {
          fit = true;
      } else if (width <= jar.contain_depth && length <= opening_width && height <= opening_length) {
          fit = true;
      } else if (width <= jar.contain_depth && length <= opening_length && height <= opening_width) {
          fit = true;
      }
    } else {
      fit = true;
    }

    return fit;
};

var confirmJar = function(jar, min_volume, knicks, callback) {
	
	jar = {};
	jar.handle = "gift-packaging";
	jar.product_id = config.jar.product_id;
	jar.variant_id = config.jar.variant_id;
	
	if(typeof callback === "function") {
		callback(jar);
	}
	
	return;
	
	var url = "/collections/containers?&view=json";
	updateUserFavorites(function() {
    $.getCustomJSON(url, function(err,data) {
		
		var tmp = $('<div class="river-grid row"></div>');
        $("#add-to-cart-confirm-container").html(tmp);
        $confirmgrid = $(tmp);

        //Find the containers that fit the requirements.
        for(var i in data.results) {
          var item = data.results[i];

          var contain_width = 0;
          var contain_depth = 0;
          var contain_length = 0;
          var max_fill = 1;
          var open_length = 0;
          var open_width = 0;

          //Loop through the variants and find ones that match our criteria.

          var valid_variants = [];
          var valid_variant_options = {
            var1: [],
            var2: []
          };

          for(var j in item.variants) {
            var variant = item.variants[j];

            contain_width = 0;
            contain_depth = 0;
            contain_length = 0;
            max_fill = 1;
            open_length = 0;
            open_width = 0;

            if(item.product.metafields) {
              contain_width = item.product.metafields['contain-width'];
              contain_depth = item.product.metafields['contain-depth'];
              contain_length = item.product.metafields['contain-length'];
              max_fill = item.product.metafields['max-fill'];
              open_length = item.product.metafields['open-length'];
              open_width = item.product.metafields['open-width'];
            }

            if(variant.metafields) {
              if(variant.metafields['contain-width']) {
                contain_width = variant.metafields['contain-width'];
              }

              if(variant.metafields['contain-depth']) {
                 contain_depth = variant.metafields['contain-depth'];
              }

              if(variant.metafields['contain-length']) {
                contain_length = variant.metafields['contain-length'];
              }

              if(variant.metafields['max-fill']) {
                max_fill = variant.metafields['max-fill'];
              }

              if(variant.metafields['open-length']) {
                open_length = variant.metafields['open-length'];
              }

              if(variant.metafields['open-width']) {
                open_width = variant.metafields['open-width'];
              }
            }

            volume = contain_width * contain_length * contain_depth * max_fill;

            if(volume >= min_volume) {

				var tmp_jar = {};
				tmp_jar.open_width = open_width;
				tmp_jar.open_length = open_length;
				tmp_jar.contain_depth = contain_depth;
				
				var found = true;
				for(var x=0; x < knicks.length; x++) {
					if(!knickFitInJar(knicks[x], tmp_jar)) {
						found = false;
					}
				}
				
				
              if(found) {
                valid_variants.push(variant); 
                $.each( variant.title.split(' / '), function(i,v) { 
                  if ( v == 'Default Title') return; 
                  var $i = 'var' + ( i + 1 ),
                      idx = $.inArray( v, item.variant_options[$i] );
                  item.variant_options[$i][idx] && valid_variant_options[$i].push(item.variant_options[$i][idx]);
                });
              }
            }
          }

          item.variants = valid_variants;
          item.variant_options.var1 = valid_variant_options.var1;
          item.variant_options.var2 = valid_variant_options.var2;

          item.upsell_container = true;
		  
			item.columns = {};
		
			if(item.variants.length) {
	
				if(jar) {
					var price = item.product.price;
					var jar_price = jar.price / 100;
					price = Math.abs(price - jar_price);
				
					if(item.product.price - jar_price === 0) {
						item.product.display_price = "$ 0";
					} else if(item.product.price < jar_price) {
						item.product.display_price = "-$ " + price;
					} else {
						item.product.display_price = "+$ " + price;
					}
				}
				
				if (jar.product_id == item.product.id || item.product.title.indexOf(jar.product_title) >=0 ) {
					item.columns.desktop = 2;
					$("#add-to-cart-confirm-container").show();
					addToRiver(item,$confirmgrid).then(function(item) {
						$(item).addClass("confirmed");
						$(item).find("#use-container-btn").html("CONFIRM CONTAINER");
					});
				} else {
					item.columns.desktop = 2;
					addToRiver(item,$confirmgrid);
				}
			}
        }
		
        if($('#add-to-cart-confirm-container .river-tile.jar').length > 0) {
			//$('#upsell-message').html("<h1>Please Confirm Your Container</h1>");

			$('#add-to-cart-confirm-container .river-tile.jar').each(function() {
				// Initialize image and price
				$(this).find('select.variant-select').trigger('change');
				// Bind event for "use container" button
				$(this).find('#use-container-btn').on('click', function(event) {
					event.stopPropagation();
					var jar = buildJar( $(this).closest(".river-tile") );
		
					//$('html, body').animate({scrollTop : 0},800);
					//$(this).closest(".modal").modal('hide');
					
					$(this).closest(".river-grid").find(".river-tile").removeClass("confirmed");
					$(this).closest(".river-tile").addClass("confirmed").addClass("no-hover");
		
					if(jar) {
						if(typeof callback === "function") {
							callback(jar);
						}
					  
					} else {
						if(typeof callback === "function") {
							callback();
						}
						console.log("DEBUG: upSellJar() — There is no jar."); 
					}
				});
			});

        }
        
        $('#add-to-cart-modal').modal('show');
		$('#add-to-cart tabs').hide();
		$("#confirm-packaging-tab").show();
      });
  });
};

var upSellJar = function(min_volume, knicks, message, callback) {

	
	var jar = {};
	jar.handle = "gift-packaging";
	jar.product_id = config.jar.product_id;
	jar.variant_id = config.jar.variant_id;
	
	if(typeof callback === "function") {
		callback(jar);
	}
	
	return;

	var url = "/collections/containers?&view=json";
  
  updateUserFavorites(function() {
    $.getCustomJSON(url, function(err,data) {
		$("#confirm-container").html('');
        var tmp = $('<div class="river-grid row"></div>');
        $("#upsell-list").html(tmp);

        $newgrid = $(tmp);//.masonry( masonryOptions );

        //Find the containers that fit the requirements.
        for(var i in data.results) {
          var item = data.results[i];

          var contain_width = 0;
          var contain_depth = 0;
          var contain_length = 0;
          var max_fill = 1;
          var open_length = 0;
          var open_width = 0;

          //Loop through the variants and find ones that match our criteria.

          var valid_variants = [];
          var valid_variant_options = {
            var1: [],
            var2: []
          };

          for(var j in item.variants) {
            var variant = item.variants[j];

            contain_width = 0;
            contain_depth = 0;
            contain_length = 0;
            max_fill = 1;
            open_length = 0;
            open_width = 0;

            if(item.product.metafields) {
              contain_width = item.product.metafields['contain-width'];
              contain_depth = item.product.metafields['contain-depth'];
              contain_length = item.product.metafields['contain-length'];
              max_fill = item.product.metafields['max-fill'];
              open_length = item.product.metafields['open-length'];
              open_width = item.product.metafields['open-width'];
            }

            if(variant.metafields) {
              if(variant.metafields['contain-width']) {
                contain_width = variant.metafields['contain-width'];
              }

              if(variant.metafields['contain-depth']) {
                 contain_depth = variant.metafields['contain-depth'];
              }

              if(variant.metafields['contain-length']) {
                contain_length = variant.metafields['contain-length'];
              }

              if(variant.metafields['max-fill']) {
                max_fill = variant.metafields['max-fill'];
              }

              if(variant.metafields['open-length']) {
                open_length = variant.metafields['open-length'];
              }

              if(variant.metafields['open-width']) {
                open_width = variant.metafields['open-width'];
              }
            }

            volume = contain_width * contain_length * contain_depth * max_fill;

            if(volume >= min_volume) {

				var tmp_jar = {};
				tmp_jar.open_width = open_width;
				tmp_jar.open_length = open_length;
				tmp_jar.contain_depth = contain_depth;
				
				var found = true;
				for(var x=0; x < knicks.length; x++) {
					if(!knickFitInJar(knicks[x], tmp_jar)) {
						found = false;
					}
				}
				
				
              if(found) {
                valid_variants.push(variant); 
                $.each( variant.title.split(' / '), function(i,v) { 
                  if ( v == 'Default Title') return; 
                  var $i = 'var' + ( i + 1 ),
                      idx = $.inArray( v, item.variant_options[$i] );
                  item.variant_options[$i][idx] && valid_variant_options[$i].push(item.variant_options[$i][idx]);
                });
              }
            }
          }

          item.variants = valid_variants;
          item.variant_options.var1 = valid_variant_options.var1;
          item.variant_options.var2 = valid_variant_options.var2;

          item.upsell_container = true;

          if($('#upsell-list .river-tile.jar').length > 4) {
            //Only show three containers.
            break;
          } else {
            if(item.variants.length) {
              addToRiver(item,$newgrid); 
            }
          }
        }
		
		var jar = {};		
		
		
        if($('#upsell-list .river-tile.jar').length > 0) {
			
			if(!message) {
				if(jar.id) {
				  $('#upsell-message').html("<h1>You Need A Bigger Container</h1><p>Unlike Mary Poppins&rsquo; magical &ldquo;bigger on the inside&rdquo; handbag, Knack containers can only hold so many goodies. To make sure all your treasures fit just right, we recommend one of these larger containers.</p>");
				} else {
					$('#upsell-message').html("<h1>Please Choose A Container</h1><p>Your gift is almost finished--contain yourself! Your gift items will look great and fit just right in any of the options below. Click Use Container to add to your gift.</p>");
				}
			} else {
				$('#upsell-message').html(message);
			}
          
          $('#upsell-list .river-tile.jar').each(function() {
            // Initialize image and price
            $(this).find('select.variant-select').trigger('change');
            // Bind event for "use container" button
            $(this).find('#use-container-btn').one('click', function(event) {
              event.stopPropagation();
              var jar = buildJar( $(this).closest(".river-tile") );

              //$('html, body').animate({scrollTop : 0},800);
              $(this).closest(".modal").modal('hide');

              if(jar) {
                  /*
                  if(!largeEnoughJar(jar)) {
                    console.log("Picked a jar that doesn't work.");
                  }
                  */
                  
                
				if(typeof callback === "function") {
					callback(jar);
				}
                
              } else {
				if(typeof callback === "function") {
					callback();
				}
                alert("DEBUG: upSellJar() — There is no jar."); 
              }
            });
          });

        } else {

			if(!message) {
				if(jar.id) {
				  $('#upsell-message').html("<h1>You Need A Bigger Container</h1><p>Unlike Mary Poppins&rsquo; magical &ldquo;bigger on the inside&rdquo; handbag, Knack containers can only hold so many goodies. To make sure all your treasures fit just right, we recommend one of these larger containers.</p>");
				} else {
					$('#upsell-message').html("<h1>Please Choose A Container</h1><p>Your gift is almost finished--contain yourself! Your gift items will look great and fit just right in any of the options below. Click Use Container to add to your gift.</p>");
				}
			} else {
				$('#upsell-message').html(message);
			}
			
        	var button = $("<button>OK</button>");
          $('#upsell-list').html("").append(button);
          $(button).one('click', function() {
            $(this).closest(".modal").modal('hide');
          });
		  
			if(typeof callback === "function") {
				callback();
			}
        }
        
        $('#upsell-container-modal').modal('show');  
      });
  });
};

var buildJar = function(data) {
  var variant_id, variant_name, qty;
  if(data.data("variant-name")) {
	variant_name = data.data("variant-name");
  } else {
	variant_name = $(data).find("select.variant2").val() || $(data).find(".single-option-selector[data-option=option1]").val();
	
	if ($(data).find(".single-option-selector[data-option=option2]")) {
		variant_name += " / " + $(data).find(".single-option-selector[data-option=option2]").val();
	}
  }

  if(data.data("qty")) {
	qty = data.data("qty");
  } else {
	qty = $(data).find(".variant1").val() || $(data).find("#product-quantity").val();
  }
  
  if (!qty) {
	qty = 1;
  }
  
  if( $(data).find("select.variant1").val() ) {
    variant_name = $(data).find("select.variant1").val();
    if($(data).find("select.variant2").val()) {
      variant_name += " / " + $(data).find("select.variant2").val();
    }
  } else if( $(data).find("#variant-select-option-0").val() ) {
    variant_name = $(data).find("#variant-select-option-0").val();
    if($(data).find("#variant-select-option-1").val()) {
      variant_name += " / " + $(data).find("#variant-select-option-1").val();
    }
  } else if( $(data).find('select.variant-select').val() ) {
    variant_id = $(data).find('select.variant-select').val();
    variant_name = $(data).find('select.variant-select :selected').text();
  } else {
    variant_id = data.data('item-variant-id-1');
    variant_price = data.data('item-variant-price-1');
    variant_price_currency = data.data('item-variant-price-currency-1');
    
    if(data.data('item-variant-title-1') != "Default Title") {
      variant_title = data.data('item-variant-title-1');
    } else {
      variant_title = ""; 
    }
    
    if(data.data('item-variant-image-' + i)) {
      variant_image = data.data('item-variant-image-' + i);
      variant_image_medium = data.data('item-variant-image-medium-' + i);
    } else {
      variant_image = data.data('item-image');
      variant_image_medium = data.data('item-image-medium');
    }
  }
  
  //Find the right variant id.
  var v_count = data.data('item-variant-count');

  //set up the defaults.
  if(data.data('item-max-fill')) {
    variant_max_fill = data.data('item-max-fill');
  } else {
    variant_max_fill = 1;
  }
  
  variant_shape = data.data('item-shape');
  variant_open_width = data.data('item-open-width');
  variant_open_length = data.data('item-open-length');
  variant_contain_width = data.data('item-contain-width');
  variant_contain_length = data.data('item-contain-length');
  variant_contain_depth = data.data('item-contain-depth');
  
  variant_available = data.data('item-variant-available-1');
  variant_inventory_quantity = data.data('item-variant-inventory-quantity-1');
  
  if(data.data('item-shape') == "circle") {
    variant_shape = data.data('item-shape');
    variant_open_diameter = data.data('item-open-diameter');
    variant_contain_diameter = data.data('item-contain-diameter');

  } else if(data.data('item-shape') == "box") {
    variant_shape = data.data('item-shape');
  }
  
  if(variant_name) {
    var split_arr = variant_name.split('/');
    for(var i=1; i <= v_count; i++) {
      var found = true;
      split_tmp = data.data('item-variant-title-' + i).toString().split('/');

      for(var j=0; j < split_arr.length; j++) {

		if(split_arr[j] && split_tmp[j]) {
			if(split_arr[j].trim() != split_tmp[j].trim()) { 
			  found = false; 
			}
		}
      }

      if(found) {
        variant_id = data.data('item-variant-id-' + i);
        variant_price = data.data('item-variant-price-' + i);
        variant_price_currency = data.data('item-variant-price-currency-' + i);
		
		variant_available = data.data('item-variant-available-' + i);
		variant_inventory_quantity = data.data('item-variant-inventory-quantity-' + i);

        if(data.data('item-variant-title-' + i) != "Default Title") {
          variant_title = data.data('item-variant-title-' + i);
        } else {
          variant_title = ""; 
        }

        if(data.data('item-variant-image-' + i)) {
          variant_image = data.data('item-variant-image-' + i);
          variant_image_medium = data.data('item-variant-image-medium-' + i);
        } else {
          variant_image = data.data('item-image');
          variant_image_medium = data.data('item-image-medium');
        }

        if(data.data('item-variant-open-width-' + i)) {
          variant_open_width = data.data('item-variant-open-width-' + i);
        }

        if(data.data('item-variant-open-length-' + i)) {
          variant_open_length = data.data('item-variant-open-length-' + i);
        }

        if(data.data('item-variant-contain-width-' + i)) {
          variant_contain_width = data.data('item-variant-contain-width-' + i);
        }

        if(data.data('item-variant-contain-length-' + i)) {
          variant_contain_length = data.data('item-variant-contain-length-' + i);
        }

        if(data.data('item-variant-contain-depth-' + i)) {
          variant_contain_depth = data.data('item-variant-contain-depth-' + i);
        }

        if(data.data('item-variant-max-fill-' + i)) {
          variant_max_fill = data.data('item-variant-max-fill-' + i);
        }

        if(data.data('item-variant-shape-' + i)) {
          variant_shape = data.data('item-variant-shape-' + i);
        }

      }
    }
  }
  
  var jar = {};
  
  if(variant_id) {
    jar.product_id = data.data('product-id');
    jar.variant_id = variant_id;
	jar.variant_available = variant_available;
	jar.variant_inventory_quantity = variant_inventory_quantity;
    jar.product_title = data.data('item-name');
    jar.handle = data.data('item-handle');
    jar.variant_title = variant_title;
    jar.price = variant_price;
    jar.price_currency = variant_price_currency;
    jar.vendor = data.data('item-vendor');
    jar.vendor_handle = data.data('item-vendor-handle');
    jar.vendor_profile = data.data('item-vendor-profile');
    jar.max_fill = variant_max_fill;

    if(variant_image) {
      jar.image = variant_image;
    	jar.image_medium = variant_image_medium;
    } else {
      jar.image = data.data('item-image');
      jar.image_medium = data.data('item-image-medium');
    }

    jar.shape = variant_shape;
    
    if(variant_shape == "circle") {
      //jar.open_diameter = variant_open_diameter;
      //jar.contain_diameter = variant_contain_diameter;
    }

    jar.open_width = variant_open_width;
    jar.open_length = variant_open_length;
    jar.contain_width = variant_contain_width;
    jar.contain_length = variant_contain_length;
    jar.contain_depth = variant_contain_depth;

    if(!jar.shape) {
      console.log("No shape for jar");
      return false;
    }
    
    if(!jar.open_width) {
      console.log("No open width for jar");
      return false; 
    } 
    
    if(!jar.open_length) {
      console.log("No open length for jar");
      return false;
    }
    
    if(!jar.contain_width) {
      console.log("No contain width for jar"); 
    }
    
    if(!jar.contain_length) {
      console.log("No contain length for jar"); 
    }
    
    if(!jar.contain_depth) {
      console.log("No contain depth for jar"); 
    }
    
	return jar;
  }
       
  return false;
};

var loadRiverUrlData = function() {
	
};

var cacheRiverUrlData = function() {
	for(var i=0; i < river_url.length; i++) {
		
		var tmp = function(count) {
			
		};
		
		tmp(i)
		$.getCustomJSON(url, function(err,data) {
			
		});
	}
}

var infinteScroll = function(config) {
  
  if(river_url[0]) {
    //Lets load up all the URLS we can.

    var pre_count = $(config.grid_selector).find('.river-tile').length;
    var load_count = 18;
    if (typeof river_url == "object") {
      var tmp = {url:river_url[0],data:river_data};
    } else {
      var tmp = {url:river_url[0],data:river_data};
    }
    
    var tmp = {url:river_url[0],data:river_data};
    if (config && config.ga) {
      tmp.ga = config.ga;
    }
    
    if (river_data) {
      if (typeof river_data.addToRiver === "function") {
        tmp.addToRiver = river_data.addToRiver;
      }
      
      if (typeof river_data.buildRiverItem === "function") {
        tmp.buildRiverItem = river_data.buildRiverItem;
      }
      
      if (typeof river_data.getRiverResults === "function") {
        tmp.getRiverResults = river_data.getRiverResults;
      }
    }
    
    if (config) {
      if (typeof config.addToRiver === "function") {
        tmp.addToRiver = config.addToRiver;
      }

      if (typeof config.product_filter === "function") {
        tmp.product_filter = config.product_filter;
      }
      
      if (typeof config.buildRiverItem === "function") {
        tmp.buildRiverItem = config.buildRiverItem;
      }
      
      if (typeof config.getRiverResults === "function") {
        tmp.getRiverResults = config.getRiverResults;
      }
      
      if (config.fullDetails) {
        tmp.fullDetails = true;
      }
			
			if (config.force_display_all) {
        tmp.force_display_all = true;
      }
      
      if (config.addItem) {
        tmp.addItem = true;
      }

      if (config.include_tags) {
        tmp.include_tags = true;
      }
      
      if (config.page) {
        tmp.page = page;
      }
      
      if (config.showAddToCart) {
        tmp.showAddToCart = true;
      }
      
      if (config.showCustomizeButton) {
        tmp.showCustomizeButton= true;
      }
      
      if (config.showAddToGift) {
        tmp.showAddToGift = true;
      }
      
      if (config.showModal) {
        tmp.showModal = true;
      }
      
      if (config.current_collection) {
        tmp.current_collection = config.current_collection;
      }
      
      if (config.prependUrl) {
        tmp.prependUrl = config.prependUrl;
      }
      
      if (config.columns) {
        tmp.columns = config.columns;
      }
      
      if(config.page) {
        tmp.page = config.page;
      }
			
			if(config.price) {
        tmp.price = config.price;
      }
      
      if(config.load_count) {
        tmp.loadCount = config.load_count;
        load_count = config.load_count;
      }
      
      if(config.template) {
        tmp.template = config.template;
      }
      
      tmp.search_hash = config.search_hash;
      
      tmp.grid_selector = config.grid_selector;
      
    } else {
      tmp.grid_selector = "#content-river > div";
    }

    loadRiverItems(load_count, tmp, function(finished) {

      $("body").trigger("river-added");
      $(config.grid_selector).trigger("river-added");

      if(finished) {
        if(river_url.length == 1) {
          $("body").trigger("river-done");
          $(config.grid_selector).trigger("river-done");
        }
      }
      
            
      
      var post_count = $(config.grid_selector).find('.river-tile').length;

      if(pre_count == post_count) {
        //Nothing has been added.  Lets go for the next URL in the queue;
        $(config.grid_selector).find(".load-more-river").remove();
        $(".collection-pagination").hide();

        river_url.shift();
        page = 0;
        if(river_url.length) {
          infinteScroll(config);
        } else {
          $("body").trigger("river-done");
          $(config.grid_selector).trigger("river-done");
        }

      } else if(post_count - pre_count < load_count) {
        river_url.shift();
        $("body").trigger("river-page-complete");
        $(config.grid_selector).trigger("river-page-complete");

        page = 0;
        if(river_url.length) {
          infinteScroll(config);
        } else {
          $("body").trigger("river-done");
          $(config.grid_selector).trigger("river-done");
        }
      }

      if($(config.grid_selector).find('.river-tile').length === 0) {
        if(config && config.no_items_url) {
          river_url.push(config.no_items_url);
          config.no_items_url = null;
          river_data = {};
          resetFilters();
          addFilters(["COLLECTION:default-related-items"]);
          //river_config = {"showModal": true,"fullDetails":true, "addItem": true};
          infinteScroll(river_config);
        } else {
          $("body").trigger("river-done");
          $(config.grid_selector).trigger("river-done");
          $(config.grid_selector).append('<p id="no-items-found-label">No items found for selected filters/search.</p>');
        }
      }
    });
  } else {
    config.$grid.find(".load-more-river").remove();
    $("body").trigger("river-done");
    config.$grid.trigger("river-done");
  }
};

var getFilters = function(page,cats, filters, callback) {
  if(!cats) {
  	cats = []; 
  }
  
  if(!page) {
  	page = 1; 
  }
  
  if(!filters) {
  	filters = []; 
  }
  var url = "/search?&page=" + page + "&view=json&type=product&q=(product_type:Knicks OR product_type:'Published Knacks' OR product_type:Containers)";
  
  $.getCustomJSON(url, function(err,data) {
    
    if(data.results.length) {
      for(var i in data.results) {
        for(var j in data.results[i].product.tags) {
          var tmp = data.results[i].product.tags[j].split(":");
          if(tmp.length > 1) {
            
            if(cats.indexOf(tmp[0].toLowerCase()) === -1) {
            	cats.push(tmp[0].toLowerCase());
            }
            
            if(filters.indexOf(data.results[i].product.tags[j]) === -1) {
            	filters.push(data.results[i].product.tags[j]);
            }
          }
        }
      }
      getFilters(++page,cats,filters,callback);
    } else {
      if(typeof callback === "function") {
      	callback(cats,filters); 
      }
    }
  });
}

var contentRiverLoaded = function() { };

// $(document).on('mouseout', ".knick-tile", function() {
//   if(!$(this).find(".knick-overlay").is(":hover")) {
// 	$(this).find(".share-buttons").hide();
//   }
// });

$(document).on('change','.river-tile select', function() {
	var data = $(this).closest('.river-tile');
  
	if(!data.hasClass('no-update')) {
		if( data.hasClass('knick') ) {
		  var knicks = buildKnick(data);
		  if(knicks[0]) {
			data.find('.knick-price').html(knicks[0].price_currency); 
			data.find('.image').css('background-image', 'url(' + knicks[0].image + ')');
		  } else {
			alert("DEBUG: .knick-tile select change — Invalid/Missing Knick.");
		  }
		} else if( data.hasClass('jar') ) {
		  var new_jar = buildJar(data);
		  
		  if(new_jar) {
			  var jar = {};
			  new_jar.display_price = new_jar.price;
			  
			  if($("#knack-inside .knick-wrapper.jar").length) {
				  $("#knack-inside .knick-wrapper.jar").each(function() {
					var variant_title = "Default Title";
					if ($(this).find(".single-option-selector[data-option=option1]").val()) {
					  variant_title = $(this).find(".single-option-selector[data-option=option1]").val();
					}
					
					if ($(this).find(".single-option-selector[data-option=option2]").val()) {
					  variant_title = variant_title + " / " + $(this).find(".single-option-selector[data-option=option2]").val();
					}
					
					$(this).data("variant-name", variant_title);
					$(this).data("qty", 1);
					
					jar = buildJar($(this));
				  });
			  }
			  
			  
			  if(jar && jar.price) {
				  var price = new_jar.price;
				  var jar_price = jar.price / 100;
				  price = Math.abs(price - jar_price);
			  
				  if(new_jar.price - jar_price === 0) {
					  new_jar.display_price = "$ 0";
				  } else if(new_jar.price < jar_price) {
					  new_jar.display_price = "-$ " + price;
				  } else {
					  new_jar.display_price = "+$ " + price;
				  }
			  }
			  data.find('.knick-price').html(new_jar.display_price); 
			  data.find('.image').css('background-image', 'url(' + new_jar.image + ')');
		  } else {
			alert("DEBUG: .knick-tile select change — Invalid/Missing Container."); 
		  }
		}
	}
});

// $(document).on('click', '.river-tile.jar .knick-overlay .details .btn-left', function() {
//     var jar = buildJar($(this).closest(".river-tile"));
    
//     if(jar) {
//       if(typeof frames['maker-frame'] === "undefined") {
//         window.location = "/?product=" + jar.handle + "#make";
//       } else {
      
//       	updateJar(jar);
//       	$('html, body').animate({scrollTop : 0},800);
//       }
//     } else {
//     	alert("DEBUG: click .river-tile.jar, .knick-overlay, .details, .btn-left, — Invalid/Missing Container."); 
//     }
// });


$(document).on('change', '#knack-modal #variant-select', function() {
  var data = $(this).closest(".modal-body");

  if(data.hasClass("knick")) {
    var knicks = buildKnick(data);
  } else if(data.hasClass("jar")) {
    var jar = buildJar(data);
  }
});


$(document).on('click', "#btn-add-knick", function(){
	var knicks = buildKnick($(this).closest(".modal-body"));
	var qty = $(this).closest(".modal-body").find("#product-quantity").val();

	for(var i=0; i < qty; i++) {
		var $item = $(this).closest(".knick");
		//$('body').trigger('add-item', [knicks[0], 1, $item]);
		$("body").trigger("add-item", [{item:knicks[0], qty:1, after:false, callback:null, no_track_event:false, show_notifications:true, customized:true}]);
	}
	
	$(this).closest(".modal").modal('hide');
});

$(document).on('click', "#btn-add-container", function(){
  var jar = buildJar($(this).closest(".modal-body"));
  
  if(jar) {
    
    if(typeof frames['maker-frame'] === "undefined") {
      window.location = "/?product=" + jar.handle + "&v=" + jar.variant_id + "&t=jar#add";
    } else {
      updateJar(jar);
      $('html, body').animate({scrollTop : 0},800);
      $(this).closest(".modal").modal('hide');
    }
  } else {
    alert("DEBUG: click #btn-add-container — Invalid/Missing Container.");  
  }
});

$(document).on('click','#btn-add-knack-cart', function() {
	
	var me = $(this);
	$(this).prop('disabled', true)
		.addClass('disabled')
		.data('original-text', $(me).text() )
		.text('Making your Knack');
	
	var knack = $(this).closest(".modal-body");
	var items = $(knack).find("#knack-contents li");
	var data = {};
	var knicks = [];
	var jar = {};
	
	
	for (var i=0; i < $(items).length; i++) {
		if (i==0) {
			//this is the jar.
			jar.handle = $(items[i]).data("product-handle");
			jar.variant_id = $(items[i]).data("product-variant-id");
			jar.image = $(items[i]).find("img").attr("src");
		} else {
			knicks.push({"handle": $(items[i]).data("product-handle"), "variant_id": $(items[i]).data("product-variant-id"), "image": $(items[i]).find("img").attr("src")});
		}
	}
	
	data.jar = JSON.stringify(jar);
	data.knicks = JSON.stringify(knicks);
	data.title = $(knack).data("item-name");
    data.public_knack = true;
  
	$.post("https://" + config.api.host + "/make/create", data,
	function(data, status) {
		if (!data.productid) {
			$(me).text( $(this).data('original-text') )
				.prop('disabled', false)
				.removeClass('disabled');
			alert("An error occured while creating your knack. Please try again.");
		} else {
			var cart = {quantity:1, id: data.productid,properties: {}};
			cart.properties.Knicks = [];
			
			for(var i=0; i < knicks.length; i++) {
				cart.properties.Knicks.push({image: knicks[i].image});
			}
			
			if (typeof fqp !== "undefined") {
				fbq('track', "AddToCart", {"type":"knack"});
			}
			
			parent.$('body').trigger('knack-made',$(knack).data("item-name"));
			
			$.ajax({
				url: "/cart/add.js",
				data: cart,
				contentType: "application/json",
				dataType: "json",
				error: function(){
					alert("An error occured while adding the knack to your cart. Please try again.");
					$(me).text( $(this).data('original-text') )
											 .prop('disabled', false)
											 .removeClass('disabled');
				},
				success: function(result){
					parent.window.location = "/cart";
				}
			});
		}
	});
});

$(document).on('click','#btn-make', function() {
  var data = $(this).closest(".modal-body");
  
  if(typeof frames['maker-frame'] === "undefined") {
    var product_id = $(data).data('product-id');
    var variant_id = $(data).data('item-variant-id-1');
	var handle = $(data).data('item-handle');
    
    window.location = "/?knack_pid=" + product_id + "&knack_vid=" + variant_id + "&knack_handle=" + handle;
  } else {
    var product_id = $(data).data('product-id');
    var variant_id = $(data).data('item-variant-id-1');
	var handle = $(data).data('item-handle');

    $("#knack-modal").modal('hide');
    $('html, body').animate({scrollTop : 0},800);
	
	setCookie("knack_id",0,false);
    
    setTimeout(function() {
      loadCreatedKnackToMaker(product_id,variant_id, handle, function() {
        
        setTimeout(function() {
        	window.location.hash = '#make';
          makerLoaded();
        }, 200);
      });
    }, 1000);
  }
});

$(document).on('click', '.river-tile .add-item', function() {
	
	$item = $(this).closest(".river-tile");
	$item.data("qty", 1);
	$item.data("variant_name", $item.data("item-variant-title-1"));
	
	var knick = buildKnick($item);
	
	$('body').trigger('add-item', [knick, 1, $item, null, false, true]);
});
  
// $(document).on('click','.river-tile.knack .knick-overlay .details .btn-left', function() {
//   var data = $(this).closest(".river-tile");

//   if(typeof frames['maker-frame'] === "undefined") {
//     var product_id = $(data).data('product-id');
//     var variant_id = $(data).data('item-variant-id-1');
    
//     window.location = "/?knack_pid=" + product_id + "&knack_vid=" + variant_id;
//   } else {
  
//     var product_id = $(data).data('product-id');
//     var variant_id = $(data).data('item-variant-id-1');
//     $('html, body').animate({scrollTop : 0},800);
//     loadCreatedKnackToMaker(product_id,variant_id, function() {
//       makerLoaded(); 
//     });
//   }
// });

// $(document).on('click', '.river-tile.knick .knick-overlay .details .btn-left', function() {
//   var knicks = buildKnick($(this).closest(".river-tile"));
  
//   if(knicks[0]) {
//     if(typeof frames['maker-frame'] === "undefined") {
//       window.location = "/?product=" + knicks[0].handle + "#make";
//     } else {
    
//       for(var i=0; i < knicks.length; i++) {
//             addKnick(knicks[i]); 
//         }
//       $('html, body').animate({scrollTop : 0},800);
//       $(this).closest(".modal").modal('hide');
//     }
//    } else {
//      alert("DEBUG: click .river-tile.knick, .knick-overlay, .details, .btn-left — Invalid/Missing Knick.");  
//    }
// });

$(document).on('click', "#btn-add-to-cart", function(){
  
    var data = $(this).closest(".modal-body");

    var item = {};
    if(data.hasClass("knick")) {
      var knicks = buildKnick(data);
      item = knicks[0];
    } else if(data.hasClass("jar")) {
      item = buildJar(data);
    } 

    var cart = {quantity:$("#product-quantity").val(), id: item.variant_id};

    $.ajax({
      url: "/cart/add.js",
      data: cart,
      contentType: "application/json",
      dataType: "json",
      success: function(result){
        ga('send', 'event', 'cart', 'add-item',item.handle);
		
		if (typeof fqp !== "undefined") {
			fbq('track', "AddToCart", {"type":"item"});
		}
        $('#header-shopping-cart').popover({trigger:'manual', placement: 'bottom', title: "Added!", content: "Item has been added to your cart.  Checkout here!"});
        $("#header-shopping-cart").popover('show');
        $(document).one('click', function(){
            $('#header-shopping-cart').popover('hide');
            $("#header-shopping-cart").popover('destory');
        });
      }
    });

    $(this).closest(".modal").modal('hide');
  });

$(window).scroll(function () {
  if ($(window).scrollTop() >= $(document).height() - $(window).height() - ($(window).height() / 2) - $("#footer").height()) {

	if($("#content-river").find(".load-more-river").length > 0 ) {
	
		$("#content-river").find(".load-more-river").remove();
		$(".collection-pagination").hide();
		var config = river_config;
		if (config) {
			config.ga = true;
		} else {
			config = {};
			config.ga = true;
		}
		
		infinteScroll(config);
	}
  }
});


$(document).on("click",".load-more-river", function() {
	var config = river_config;
	if (config) {
		config.ga = true;
	} else {
		config = {};
		config.ga = true;
	}
	
  infinteScroll(config);
});

$(document).on('click',".river-tile .btn-fav", function(e) {
  e.stopPropagation();
  if(customer) {
    var me = this;
    if($(this).closest(".river-tile").hasClass("fav")) {
		ga('send', 'event', 'item', 'remove-favorite',$(this).closest(".river-tile").data("item-handle"));
      removeFavorite(customer,$(this).closest(".river-tile").data("product-id"),function(err,result) {
        $(me).closest(".river-tile").removeClass("fav");
      });
    } else {
		ga('send', 'event', 'item', 'add-favorite',$(this).closest(".river-tile").data("item-handle"));
      addFavorite(customer,$(this).closest(".river-tile").data("product-id"),function(err,result) {
        $(me).closest(".river-tile").addClass("fav");
      });
    }
  } else {
    $('#fav-login-modal').modal('show');
  }
  
  return false;
});

$(document).on('click', ".btn-share", function(){ 
 $(this).closest(".details").find(".share-buttons").toggle();
});

$(document).on('click', ".share-buttons .share", function(){ 
  window.open($(this).attr("href"), 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=1');
  return false;
});

// $(document).on('mouseover', ".knick-tile", function() { 
//   $(".knick-tile select").hide();
//   $(".knick-tile").removeClass("hover");
//  $(this).addClass("hover");
//   $(this).find("select").show();
// });

// $(document).on('mouseout', ".knick-tile", function() { 
//   if($(this).find("select:focus").length === 0) {
//     $(this).removeClass("hover");
//   }
// });

// $(document).on('click', ".knick-tile select option", function(){ 
//  $(this).closest("select").blur();
// });

var addFavorite = function(user_id,product_id,callback) {
    var data = {};
    data.user_id = user_id;
  	data.product_id = product_id;
      
  $.post("https://" + config.api.host + "/content/favorite",data,
      function(result, status) {
          callback(null,result);
      });
};

var removeFavorite = function(user_id,product_id,callback) {
    var data = {};
    data.user_id = user_id;
  	data.product_id = product_id;
      
    $.ajax({
      url: 'https://' + config.api.host + '/content/favorite',
      type: 'DELETE',
      data: data,
      success: function(data) {
          callback(null,data);
      },
      error: function(xhr, status, error) {
          var err = eval("(" + xhr.responseText + ")");
          callback(err.Message);
      }
    });
};

$(document).on('new-knack', 'body', function() {
  var r = confirm("Are you sure you want to start a new knack?");
  if (r == true) {
    setCookie("knack_id",0,false);
	ga('send', 'event', 'maker', 'new-knack');
	if(window.location.hash == "#make") {
	   window.location.reload(); 
	} else {
	  window.location.assign('/#make');
	}
  }
});

$(document).on('making-knack', 'body', function() {
  $("#knack-making-modal").modal('show');
});

$(document).on('done-making-knack', 'body', function() {
  $("#knack-making-modal").modal('hide');
});


$(document).on('knack-made', 'body', function(title) {
	ga('send', 'event', 'cart', 'add-knack',title);
});

$(document).on('maker-hide-info', 'body', function(item) {
	ga('send', 'event', 'maker', 'item-info-hide',item.handle);
});

$(document).on('maker-show-info', 'body', function(item) {
	ga('send', 'event', 'maker', 'item-info-show',item.handle);
});

$(document).on('maker-select-container', 'body', function(item) {
	ga('send', 'event', 'maker', 'select-container',item.handle);
});

$(document).on('maker-remove-item', 'body', function(item) {
	ga('send', 'event', 'maker', 'item-remove',item.handle);
});

$(document).on('save-knack', 'body', function() {
	ga('send', 'event', 'maker', 'save-knack');
});

$(function() {
	
	$("#fav-login-modal").on('shown.bs.modal', function(event) {
		ga('send', 'pageview', "/account/favorites/login");
	});
	
	$("#fav-login-modal").on('hide.bs.modal', function(event) {
		ga('send', 'pageview', document.location.pathname);
	});
	
	$("#knack-contain-modal").on('shown.bs.modal', function(event) {		
		$("#knack-modal").modal('hide');	
	});
	
	$("#knack-contain-modal").on('hide.bs.modal', function(event) {
		$("#knack-modal").modal('show')
	});
	
	$(document).on('click', "#knack-contain-modal #btn-add-knick, #knack-contain-modal #btn-add-to-cart, #knack-contain-modal #btn-add-container", function() {
		$('#knack-modal').modal('hide');
		$('#knack-contain-modal').modal('hide');
	});
	
	$("#knack-modal").on('hide.bs.modal', function(event) {
		if(!$('#knack-contain-modal').is(':visible')) {
			ga('send', 'pageview', document.location.pathname);
		}
	});
	
  $('#knack-modal, #knack-contain-modal').on('show.bs.modal', function (event) {
    var $modalContent = $(this).find('.modal-content');
    
    $modalContent.data("variant-id", "");
      if (!event.relatedTarget) {
      var $knickTile = $modalContent.find(".modal-body");
      if (typeof ga !== "undefined") {
        ga('send', 'pageview', "/products/" + $knickTile.data('item-handle'));
      }
		
		
		return;
	} else {
		var $knickTile = $(event.relatedTarget);
		
		var url = "//" + config.shopify.host + "/products/" + $knickTile.data('handle') + "?view=modal";
		ga('send', 'pageview', "/products/" + $knickTile.data('handle'));

		$modalContent.addClass('loading');
	
		$.get( url, function( data ) {
			if($knickTile.data('variant-id')) {
				$modalContent.data("variant-id", $knickTile.data('variant-id'));
			}
			
			$modalContent.html($(data));
			$modalContent.removeClass("loading");
			initNumFields( $modalContent );
    });
	}
  });
});
